import { gql } from "@apollo/client";
import { ACFMediaFragment } from "./ACF/Media";

export const PageDataFragment = gql`
  ${ACFMediaFragment}
  fragment PageData on ContentNode {
    pageData {
      ogTitle
      ogDescription
      pageCategory {
        slug
        name
      }
      featuredImage {
        ...ACFMedia
      }
    }
  }
`;
